import { useCallback } from 'react';
import { invoke } from 'lodash';

import { toggleQuestionCollapse } from '../utils';
import { isRowValuesFilled } from '../isValid';
import { ROW_LABEL_SELECTOR } from '../constants';

function isRowLabel(element) {
  if (!element) {
    return false;
  }

  return element.className.includes(ROW_LABEL_SELECTOR);
}

function shouldSkipToggleOnBlur(target, relatedTarget) {
  if (!relatedTarget) {
    return false;
  }

  const labelInvolved = isRowLabel(target) || isRowLabel(relatedTarget);
  if (!labelInvolved) {
    return false;
  }

  const originParent = invoke(target, 'closest', '.answer--matrix-open-ended');
  const destinationParent = invoke(
    relatedTarget,
    'closest',
    '.answer--matrix-open-ended',
  );

  return Boolean(originParent && originParent === destinationParent);
}

function useToggle(inputElement = 'input') {
  const onClickRowLabel = useCallback((event) => {
    toggleQuestionCollapse(event.target);
  }, []);

  const onBlurToggle = useCallback(
    (event) => {
      // clicking button row label and loses focus and fire twice onblur event
      if (shouldSkipToggleOnBlur(event.target, event.relatedTarget)) {
        return;
      }

      const originParent = invoke(
        event.target,
        'closest',
        '.answer--matrix-open-ended',
      );
      const destinationParent = invoke(
        event.relatedTarget,
        'closest',
        '.answer--matrix-open-ended',
      );

      if (
        originParent !== destinationParent &&
        isRowValuesFilled(originParent, inputElement)
      ) {
        // a bit of a hack to reuse the same toggleQuestionCollapse function
        const toggleButton = originParent.querySelector(
          `.${ROW_LABEL_SELECTOR}`,
        );
        toggleQuestionCollapse(toggleButton);
      }
    },
    [inputElement],
  );

  return {
    onClickRowLabel,
    onBlurToggle,
  };
}

export default useToggle;
